
import SBtn from '@app/shared/src/components/ui/Button/SBtn.vue';
import { defineComponent, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import RussianSoftwareRegistry from 'SharedComponents/RussianSoftwareRegistry.vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { STATIC_DOCS } from 'SharedDir/backend/endpoints/docs';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';
import { useFeatureFlags } from 'SharedDir/common/composables/useFeatureFlags';
import { FeatureFlagName } from 'SharedDir/declarations/system/region-customization';

import FeedbackModal from 'PortalDir/components/Contacts/FeedbackModal.vue';
import { ADMIN_URL, REGION_ENVIRONMENT } from 'PortalDir/constants/app/common';
import { routerInitialPath, routerMainPageName } from 'PortalDir/router/router.constants';

export default defineComponent({
  components: {
    SIcon,
    SBtn,
    FeedbackModal,
    RussianSoftwareRegistry,
  },
  setup() {
    const showDialog = ref(false);

    const { isMobile } = useDeviceSize();
    const { getFeatureFlag } = useFeatureFlags();
    const { t } = useI18n();

    // eslint-disable-next-line max-len
    const REGULATIONS_ON_PERSONAL_DATA_PROCESSING = STATIC_DOCS.REGULATIONS_ON_PERSONAL_DATA_PROCESSING.url;
    function regulationsOnPersonalDataProcessingLink() {
      return STATIC_DOCS.REGULATIONS_ON_PERSONAL_DATA_PROCESSING.url;
    }

    const PRIVACY_POLICY = STATIC_DOCS.PRIVACY_POLICY.url;
    function privacyPolicyLink() {
      return STATIC_DOCS.PRIVACY_POLICY.url;
    }

    const AGREEMENT_PERSONAL_DATA = STATIC_DOCS.AGREEMENT_PERSONAL_DATA.url;
    function userAgreementLink() {
      return STATIC_DOCS.AGREEMENT_PERSONAL_DATA.url;
    }

    const MANUAL_USER = STATIC_DOCS.MANUAL_USER.url;

    const currentYear = new Date().getFullYear();

    const isVisibleFeedbackBtn = getFeatureFlag(FeatureFlagName.IsVisibleFeedbackBtnInPortal);

    const isVisibleLinksToEthnoportalInPortal = getFeatureFlag(
      FeatureFlagName.IsVisibleLinksToEthnoportalInPortal
    );

    const isVisibleLabelWithRussianRegistry = getFeatureFlag(
      FeatureFlagName.IsInRussianSoftwareRegistry
    );

    return {
      currentYear,
      ADMIN_URL,
      routerInitialPath,
      routerMainPageName,
      showDialog,
      privacyPolicyLink,
      userAgreementLink,
      isMobile,
      PRIVACY_POLICY,
      AGREEMENT_PERSONAL_DATA,
      REGULATIONS_ON_PERSONAL_DATA_PROCESSING,
      MANUAL_USER,
      REGION_ENVIRONMENT,
      isVisibleFeedbackBtn,
      isVisibleLinksToEthnoportalInPortal,
      isVisibleLabelWithRussianRegistry,
      t,
    };
  },
});
